export const CONSENT_MANAGER_VENDOR = {
  YOUTUBE: 's30',
} as const;

export const CONSENT_MANAGER_PURPOSE = {
  ESSENTIAL: 'c1',
  MEASUREMENT: 'c54',
} as const;
